import Weeks from "./weeks/_index";

export default [
  {
    length: "2 weeks",
    title: "phase 1",
    weeks: Weeks.phase1,
  },

  {
    length: "2 weeks",
    title: "phase 2",
    weeks: Weeks.phase2,
  },

  {
    length: "2 weeks",
    title: "phase 3",
    weeks: Weeks.phase3,
  },

  {
    length: "2 weeks",
    title: "phase 4",
    weeks: Weeks.phase4,
  },

  {
    length: "2 weeks",
    title: "phase 5",
    weeks: Weeks.phase5,
  },

  {
    length: "2 weeks",
    title: "phase 6",
    weeks: Weeks.phase6,
  },

  {
    length: "1 week",
    title: "phase 7",
    weeks: Weeks.phase7,
  },
];
